/**
 * This home page for the Search app
 */
import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";

import MarketSearch from "../../components/MarketSearch";

/**
 * Home Component
 * @returns
 */
const SearchContainer = () => {
    /**
     * Handler for the Select location from the autocomplete.
     * @param {*} result
     */
    const handleSelectedLocation = (market) => {
        window.open(`/listing-search/markets/${market.id}`, "_self");
    };

    let body = (
        <>
            <MarketSearch onSelect={handleSelectedLocation}></MarketSearch>
        </>
    );

    return body;
};

export { SearchContainer };
